import ajusteEscoreReducer from "features/ajusteEscore/redux/ajusteEscoreReducer";
import relatorioReducer from "features/analiticopdf/redux/tableauReportReducer";
import avisoConsultoriaReducer from "features/avisoConsultoria/redux/avisoConsultoriaReducer";
import balancoArrobaReducer from "features/balancoDeArroba/redux/balancoArrobaReducer";
import cadastroIngredientesReducers from "features/cadastroIngredientes/redux/cadastroIngredientesReducers";
import clienteReducer from "features/cliente/redux/clienteReducer";
import conciliacaoReducer from "features/conciliacao/redux/conciliacaoReducer";
import { fechamentoConsumoReducer } from "features/fechamentoConsumo/redux/index";
import formulaReducer from "features/formulacao/redux/formulaReducer";
import historicoMovimentacaoReducer from "features/historicoMovimentacaoApp/redux/historicoMovimentacaoReducers";
import loteReducer from "features/lote/redux/loteReducer";
import cochoReducer from "features/manejo/redux/reducers/cochoReducer";
import farmReducer from "features/manejo/redux/reducers/farmReducer";
import farolReducer from "features/manejo/redux/reducers/farolReducer";
import forragemReducer from "features/manejo/redux/reducers/forragemReducer";
import kmlReducer from "features/manejo/redux/reducers/kmlReducer";
import mapaReducer from "features/manejo/redux/reducers/mapaReducer";
import moduloReducer from "features/manejo/redux/reducers/moduloReducer";
import pastoPrimeReducer from "features/manejo/redux/reducers/pastoPrimeReducer";
import pastoReducer from "features/manejo/redux/reducers/pastoReducer";
import rebanhoReducer from "features/manejo/redux/reducers/rebanhoReducer";
import uiReducer from "features/manejo/redux/reducers/uiReducer";
import vinculoReducer from "features/manejo/redux/reducers/vinculoReducer";
import { novaNotificacaoReducer } from "features/notificacao/redux";
import pesagemCategoriaReducer from "features/pesagemCategoria/redux/pesagemCategoriaReducer";
import ganhoPesoReducer from "features/projecaoGanhoPeso/redux/ganhoPesoReducers";
import retiroReducer from "features/retiro/redux/retiroReducer";
import relatoriosReducer from "features/tableauEmbedded/redux/relatoriosReducer";
import usuarioClienteReducer from "features/usuarioCliente/redux/usuarioClienteReducer";
import { combineReducers } from "redux";
import benchmarkReducer from "./benchmarkReducer";
import ageRangeReducer from "./ageRangeReducer";
import categoryReducer from "./categoryReducer";
import causeOfDeathReducer from "./causeOfDeathReducer";
import configurationReducer from "./configurationReducer";
import filterReducer from "./filterReducer";
import livestockReducer from "./livestockReducer";
import loadingReducer from "./loadingReducer";
import lotReducer from "./lotReducer";
import modalReducer from "./modalReducer";
import movementsReducer from "./movementsReducer";
import notificacaoReducer from "./notificacaoReducer";
import pastureReducer from "./pastureReducer";
import usuarioReducer from "./usuarioReducer";

const rootReducer = combineReducers({
  benchmark: benchmarkReducer,
  ajusteEscore: ajusteEscoreReducer,
  avisoConsultoria: avisoConsultoriaReducer,
  balanco: balancoArrobaReducer,
  cadastroIngredientes: cadastroIngredientesReducers,
  cliente: clienteReducer,
  cocho: cochoReducer,
  conciliacao: conciliacaoReducer,
  curvaGanhoPeso: ganhoPesoReducer,
  farol: farolReducer,
  fazenda: farmReducer,
  fechamentoConsumo: fechamentoConsumoReducer,
  filter: filterReducer,
  formula: formulaReducer,
  forragem: forragemReducer,
  historicoMovimentacao: historicoMovimentacaoReducer,
  kml: kmlReducer,
  loading: loadingReducer,
  lote: loteReducer,
  mapa: mapaReducer,
  modal: modalReducer,
  modulo: moduloReducer,
  notificacao: notificacaoReducer,
  novaNotificacao: novaNotificacaoReducer,
  pasto: pastoReducer,
  pastosPrime: pastoPrimeReducer,
  pesagemCategoria: pesagemCategoriaReducer,
  rebanho: rebanhoReducer,
  relatorio: relatorioReducer,
  relatoriosTableauEmbedded: relatoriosReducer,
  retiro: retiroReducer,
  ui: uiReducer,
  usuario: usuarioReducer,
  usuarioCliente: usuarioClienteReducer,
  vinculo: vinculoReducer,

  ageRange: ageRangeReducer,
  category: categoryReducer,
  causeOfDeath: causeOfDeathReducer,
  configurations: configurationReducer,
  livestock: livestockReducer,
  lot: lotReducer,
  movements: movementsReducer,
  pasture: pastureReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
